/*
  Marcel Afters, house system JS (STORY-BRAND-10X, 27 Sep 2026). Loaded deferred, last, on every page.
  1. Bundles: one size per piece, "Add all" through the theme's CartLinesUpdateEvent (drawer opens, count updates).
  2. Rails: arrows for .ma-x tracks.
  3. Grid breaks: <template data-ma-break> cards slotted into the product grid after N cards, re-slotted after
     filters / load more redraw the grid.
  4. Her / Him memory: a click on any Her/Him choice is remembered (localStorage ma_pref_g); Her/Him bundles open
     on it, and PDPs without their own context get it as sessionStorage ma_g (read by the gallery gender logic).
  5. Your size: when the Private Edit quiz has been taken (pr_quiz, session or local storage; top size = ts[0]), a small chip by the PDP size picker
     marks that size. It never selects it.
  6. Recently viewed: PDPs record the handle (localStorage ma_rv, 12 max); a rail on PDPs and the cart page shows
     the last pieces seen, each with quick add.
  Everything is wrapped so storage or network failures leave the page as it was.
*/
(function () {
  'use strict';
  if (window.__maSystem) return;
  window.__maSystem = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var routes = (window.Theme && Theme.routes) || {};
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', v = cents / 100;
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (v % 1 ? v.toFixed(2) : v); }
  }

  /* ---------- 1. cart ---------- */
  function sectionIds() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (n) { if (n.dataset && n.dataset.sectionId) ids.push(n.dataset.sectionId); });
    return ids;
  }
  async function addLines(source, ids, tag) {
    var mod = null, def = null;
    try { mod = await import('@shopify/events'); } catch (e) { mod = null; }
    if (mod && mod.CartLinesUpdateEvent) {
      try {
        def = mod.CartLinesUpdateEvent.createPromise();
        source.dispatchEvent(new mod.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: ids.map(function (id) { return { merchandiseId: String(id), quantity: 1 }; }), promise: def.promise }));
      } catch (e) { def = null; }
    }
    var body = { items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) };
    var sids = sectionIds(); if (sids.length) body.sections = sids.join(',');
    var ok = false, json = null, cart = null;
    try {
      var res = await fetch(routes.cart_add_url || (ROOT + 'cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: JSON.stringify(body) });
      json = await res.json(); ok = res.ok && !json.status;
      try { var cr = await fetch((routes.cart_url || (ROOT + 'cart')) + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }); cart = await cr.json(); } catch (e2) { cart = null; }
    } catch (e) { ok = false; json = { description: 'Could not reach the bag. Try again.' }; }
    if (def) {
      if (cart) def.resolve({ cart: mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: tag, sourceId: tag, itemCount: ids.length, sections: json && json.sections, didError: !ok } });
      else def.reject(new Error('cart unavailable'));
    }
    if (ok && !def && /\/cart\/?$/.test(location.pathname)) location.reload();
    return { ok: ok, json: json };
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-ma-bd-add]');
    if (!btn) return;
    var host = btn.closest('[data-ma-bundle]'), msg = host.querySelector('[data-ma-bd-msg]');
    var sels = [].slice.call(host.querySelectorAll('[data-ma-bd-size]'));
    var missing = sels.filter(function (s) { return !s.value; });
    sels.forEach(function (s) { s.classList.toggle('is-missing', !s.value); });
    msg.classList.remove('is-err');
    if (missing.length) { msg.textContent = missing.length === sels.length ? 'Choose a size for each piece.' : 'Choose a size for ' + missing.length + ' more piece' + (missing.length > 1 ? 's' : '') + '.'; missing[0].focus(); return; }
    btn.setAttribute('aria-busy', 'true'); btn.disabled = true; msg.textContent = 'Adding…';
    var r = await addLines(btn, sels.map(function (s) { return s.value; }), 'ma-bundle');
    btn.removeAttribute('aria-busy'); btn.disabled = false;
    if (r.ok) { msg.textContent = 'Added. The multi-buy saving is applied at checkout.'; if (window.gtag) try { gtag('event', 'add_to_cart', { items_count: sels.length, source: 'ma-bundle' }); } catch (e3) {} }
    else { msg.classList.add('is-err'); msg.textContent = (r.json && (r.json.description || r.json.message)) || 'Could not add. Try again.'; }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-ma-bd-size]')) {
      e.target.classList.remove('is-missing');
      var host = e.target.closest('[data-ma-bundle]'); var m = host && host.querySelector('[data-ma-bd-msg]'); if (m && !m.classList.contains('is-err')) m.textContent = '';
    }
  });

  /* ---------- 2. rails ---------- */
  function wireRail(x) {
    if (x._maw) return; x._maw = true;
    var track = x.querySelector('.ma-x__track'), nav = x.querySelector('.ma-x__nav');
    if (!track || !nav) return;
    var btns = nav.querySelectorAll('.ma-x__btn');
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      nav.hidden = max <= 0;
      btns[0].disabled = track.scrollLeft <= 2; btns[1].disabled = track.scrollLeft >= max;
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { var item = track.querySelector('li'); var w = item ? item.getBoundingClientRect().width + 16 : 300; track.scrollBy({ left: Number(b.dataset.dir) * w * 2, behavior: 'smooth' }); }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  /* ---------- 3. grid breaks ---------- */
  function placeBreaks() {
    var grid = document.querySelector('ul.product-grid');
    var tpls = document.querySelectorAll('template[data-ma-break]');
    if (!grid || !tpls.length) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    [].forEach.call(tpls, function (t, i) {
      var key = 'b' + i;
      if (grid.querySelector('.ma-brk[data-ma-key="' + key + '"]')) return;
      var after = Number(mobile ? (t.dataset.mobileAfter || t.dataset.after) : t.dataset.after) || 8;
      var items = grid.querySelectorAll(':scope > li.product-grid__item:not(.ma-brk)');
      if (items.length < after) return;
      var node = t.content.firstElementChild.cloneNode(true);
      node.dataset.maKey = key; node.classList.add('product-grid__item');
      items[after - 1].after(node);
      [].forEach.call(node.querySelectorAll('[data-ma-x]'), wireRail);
      applyPref(node);
    });
  }

  /* ---------- 4. Her / Him ---------- */
  function pref() { var g = ls('ma_pref_g'); return g === 'her' || g === 'him' ? g : ''; }
  function showDuo(duo, g) {
    var panel = duo.querySelector('[data-ma-duo-panel="' + g + '"]'); if (!panel) return;
    [].forEach.call(duo.querySelectorAll('[data-ma-duo-panel]'), function (p) { p.hidden = p !== panel; });
    [].forEach.call(duo.querySelectorAll('[data-ma-duo-tab]'), function (b) { b.setAttribute('aria-pressed', b.dataset.maDuoTab === g ? 'true' : 'false'); });
  }
  function applyPref(scope) {
    var g = pref(); if (!g) return;
    [].forEach.call((scope || document).querySelectorAll('[data-ma-rails]'), function (r) { r.classList.toggle('is-him-first', g === 'him'); });
    [].forEach.call((scope || document).querySelectorAll('[data-ma-duo]'), function (d) { showDuo(d, g); });
  }
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-ma-duo-tab]');
    if (tab) { var g = tab.dataset.maDuoTab; ls('ma_pref_g', g); showDuo(tab.closest('[data-ma-duo]'), g); return; }
    var a = e.target.closest && e.target.closest('a[href], button');
    if (!a) return;
    var label = (a.textContent || '').trim().toLowerCase();
    var href = a.getAttribute('href') || '';
    if (/^(her|for her|shop her|women|womens)$/.test(label) || /\/collections\/(her|essentials-women|athletics-women|sets-her)(\/|\?|$)/.test(href)) ls('ma_pref_g', 'her');
    else if (/^(him|for him|shop him|men|mens)$/.test(label) || /\/collections\/(him|essentials-men|athletics-men|sets-him)(\/|\?|$)/.test(href)) ls('ma_pref_g', 'him');
  }, true);
  function seedGender() {
    var p = location.pathname;
    if (/\/collections\/(her|[a-z-]*-women)(\/|$)/.test(p)) ls('ma_pref_g', 'her');
    else if (/\/collections\/(him|[a-z-]*-men)(\/|$)/.test(p)) ls('ma_pref_g', 'him');
    if (/\/products\//.test(p) && !ss('ma_g')) { var g = pref(); if (g) ss('ma_g', g); }
  }

  /* ---------- 5. your size ---------- */
  function quizSize() {
    var raw = ss('pr_quiz') || ls('pr_quiz'); if (!raw) return '';
    var s = '';
    try { var q = JSON.parse(raw) || {}; s = (Array.isArray(q.ts) ? q.ts[0] : q.ts) || q.size || ''; } catch (e) { s = ''; }
    s = String(s || '').toUpperCase().trim();
    return /^(XXS|XS|S|M|L|XL|[2-5]XL)$/.test(s) ? s : '';
  }
  function sizeChip() {
    if (!/\/products\//.test(location.pathname)) return;
    var size = quizSize(); if (!size) return;
    var fs = [].slice.call(document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, fieldset.variant-option'));
    var field = fs.filter(function (f) { var l = f.querySelector('legend'); return l && /size/i.test(l.textContent); })[0];
    if (!field || field.querySelector('.ma-yoursize')) return;
    var match = [].slice.call(field.querySelectorAll('label, input[type=radio]')).filter(function (n) {
      var t = (n.value || n.textContent || '').trim().toUpperCase(); return t === size;
    });
    if (!match.length) return;
    match.forEach(function (n) { var l = n.tagName === 'INPUT' ? field.querySelector('label[for="' + n.id + '"]') || n.closest('label') : n; if (l) l.classList.add('ma-size-mine'); });
    var chip = document.createElement('span'); chip.className = 'ma-yoursize';
    chip.innerHTML = '<span>Your size ' + size.replace(/[<>&"]/g, '') + '</span><button type="button">Not you?</button>';
    chip.querySelector('button').addEventListener('click', function () { ls('pr_quiz', null); try { sessionStorage.removeItem('pr_quiz'); } catch (e4) {} chip.remove(); [].forEach.call(document.querySelectorAll('.ma-size-mine'), function (n) { n.classList.remove('ma-size-mine'); }); });
    var legend = field.querySelector('legend');
    if (legend) legend.appendChild(chip); else field.insertBefore(chip, field.firstChild);
  }

  /* ---------- 6. recently viewed ---------- */
  function rvList() { try { return JSON.parse(ls('ma_rv') || '[]') || []; } catch (e) { return []; } }
  function rvRecord() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var h = decodeURIComponent(m[1]); var l = rvList().filter(function (x) { return x !== h; }); l.unshift(h); ls('ma_rv', JSON.stringify(l.slice(0, 12)));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) { if (!src) return ''; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  async function rvRender() {
    var host = document.querySelector('[data-ma-rv]'); if (!host) return;
    var here = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    var list = rvList().filter(function (h) { return h !== here; }).slice(0, 8);
    if (list.length < 2) return;
    /* ONE CARD CONTRACT (12 Oct 2026): each recently viewed card is the shared Alo card rendered by the store
       (templates/product.ma-card.liquid): 3:4 whole photograph, second image on hover, + quick add, bottom sheet on a phone. */
    var parts = await Promise.all(list.map(function (h) { return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=ma-card', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); }));
    parts = parts.filter(function (t) { return t && t.indexOf('mx-card') > -1; });
    if (parts.length < 2) return;
    var old = host.querySelector('[data-ma-x]'); if (!old) return;
    var rail = document.createElement('div'); rail.className = 'mx-rail mx-rail--recent'; rail.setAttribute('data-mx-rail', '');
    rail.innerHTML = '<ul class="mx-rail__list mx-scroll" role="list" data-mx-track>' + parts.map(function (c) { return '<li class="mx-rail__item">' + c + '</li>'; }).join('') + '</ul>';
    old.replaceWith(rail);
    host.hidden = false;
    document.dispatchEvent(new Event('shopify:section:load'));
    var clr = host.querySelector('[data-ma-rv-clear]');
    if (clr) clr.addEventListener('click', function () { ls('ma_rv', JSON.stringify(here ? [decodeURIComponent(here)] : [])); host.hidden = true; });
  }

  /* ---------- 7. heavyweight chips on grid cards (300 gsm+, real data: assets/ma-heavy.json) ---------- */
  var HW = null;
  function hwChips() {
    var cards = document.querySelectorAll('product-card:not([data-ma-hw])');
    if (!cards.length) return;
    var go = function () {
      /* Perf (4 Oct 2026): read everything first, write after. getComputedStyle() right after the previous card's chip was
         appended forced a style recalculation per card (up to ~300 cards on a landing page: 270 ms + 140 ms long tasks). */
      var todo = [];
      [].forEach.call(document.querySelectorAll('product-card:not([data-ma-hw])'), function (c) {
        var t = { card: c, g: '', box: null, rel: false };
        todo.push(t);
        var a = c.querySelector('a[href*="/products/"]'); if (!a) return;
        var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); if (!m) return;
        var g = HW[decodeURIComponent(m[1])]; if (!g) return;
        var box = c.querySelector('.card-gallery') || c.querySelector('.product-media-container'); if (!box || box.querySelector('.ma-hw')) return;
        t.g = g; t.box = box; t.rel = getComputedStyle(box).position === 'static';
      });
      todo.forEach(function (t) {
        t.card.setAttribute('data-ma-hw', '');
        if (!t.box) return;
        if (t.rel) t.box.style.position = 'relative';
        var chip = document.createElement('span'); chip.className = 'ma-hw'; chip.textContent = 'Heavyweight'; chip.title = t.g + ' gsm'; t.box.appendChild(chip);
      });
    };
    if (HW) return go();
    var me = document.querySelector('script[src*="ma-system.js"]');
    if (!me) return;
    fetch(me.src.replace(/ma-system\.js.*/, 'ma-heavy.json')).then(function (r) { return r.json(); }).then(function (j) { HW = j || {}; go(); }).catch(function () { HW = {}; });
  }

  ready(function () {
    seedGender();
    rvRecord();
    [].forEach.call(document.querySelectorAll('[data-ma-x]'), wireRail);
    applyPref();
    placeBreaks();
    var main = document.getElementById('MainContent');
    if (main && document.querySelector('template[data-ma-break]')) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(placeBreaks, 120); }).observe(main, { childList: true, subtree: true });
    }
    sizeChip();
    setTimeout(sizeChip, 1200);
    hwChips();
    if (main) { var ht = null; new MutationObserver(function () { clearTimeout(ht); ht = setTimeout(hwChips, 200); }).observe(main, { childList: true, subtree: true }); }
    rvRender();
  });
})();
